/**
 * 模拟返回用 axios 接口请求的数据内容
 *
 * @param param0 - 配置参数
 * @param param0.data - 模拟数据
 * @param param0.needId - 是否需要模拟 id
 * @param param0.pagination - 分野数据
 * @returns AxiosResponsePromise
 */
export const mockAxiosResponsePromise = ({ data, needId = true, pagination = null, }) => (query) => {
    let originData = data === null || data === void 0 ? void 0 : data.map((item, index) => needId
        ? Object.assign({ 
            // 模拟 id，导出时使用。不然勾选时数量统计会出现一些问题
            id: index }, item) : item);
    // 这里主要是导出时把选中的数据过滤一下返回
    if (query.idIn) {
        originData = originData.filter(item => `${query.idIn}`.includes(item.id));
    }
    return Promise.resolve({
        data: originData,
        pagination: pagination || null,
        status: 200,
        statusText: 'ok',
        headers: {},
        config: {},
    });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9jay11dGlscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tb2NrLXV0aWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUtBOzs7Ozs7OztHQVFHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sd0JBQXdCLEdBQ25DLENBQWdCLEVBQ2QsSUFBSSxFQUNKLE1BQU0sR0FBRyxJQUFJLEVBQ2IsVUFBVSxHQUFHLElBQUksR0FLbEIsRUFBRSxFQUFFLENBQ0wsQ0FBQyxLQUE2QixFQUE2QixFQUFFO0lBQzNELElBQUksVUFBVSxHQUFHLElBQUksYUFBSixJQUFJLHVCQUFKLElBQUksQ0FBRSxHQUFHLENBQUMsQ0FBQyxJQUFTLEVBQUUsS0FBYSxFQUFFLEVBQUUsQ0FDdEQsTUFBTTtRQUNKLENBQUM7WUFDRywrQkFBK0I7WUFDL0IsRUFBRSxFQUFFLEtBQUssSUFDTixJQUFJLEVBRVgsQ0FBQyxDQUFDLElBQUksQ0FDVCxDQUFBO0lBRUQsdUJBQXVCO0lBQ3ZCLElBQUksS0FBSyxDQUFDLElBQUksRUFBRTtRQUNkLFVBQVUsR0FBRyxVQUFVLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsR0FBRyxLQUFLLENBQUMsSUFBSSxFQUFFLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFBO0tBQzFFO0lBRUQsT0FBTyxPQUFPLENBQUMsT0FBTyxDQUFDO1FBQ3JCLElBQUksRUFBRSxVQUFVO1FBQ2hCLFVBQVUsRUFBRSxVQUFVLElBQUksSUFBSTtRQUM5QixNQUFNLEVBQUUsR0FBRztRQUNYLFVBQVUsRUFBRSxJQUFJO1FBQ2hCLE9BQU8sRUFBRSxFQUFFO1FBQ1gsTUFBTSxFQUFFLEVBQUU7S0FDWCxDQUFDLENBQUE7QUFDSixDQUFDLENBQUEifQ==